import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { map, catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { Vlan } from '../models/vlan';
import { ConsultaVlansDto } from '../models/consulta-vlans-dto';

@Injectable()
export class VlanService {

  private urlEndPointVlan: string = environment.vlanEndPoint;

  constructor(private http: HttpClient) { }

  // el parametro estado hace referencia si se desea filtrar vlans Activas (true)
  // o sin importar su estado (false)
  vlansPorSedeAmbienteCompania(idSede: number, idAmbiente: number,
    idCompania: number, estado: boolean): Observable<Vlan[]> {
    return this.http.get(this.urlEndPointVlan + 'sede/' + idSede + '/ambiente/' + idAmbiente +
    '/compania/' + idCompania + '/' + estado).pipe(
      map((resultado) => resultado as Vlan[]),
    );
  }

  vlansActivas(): Observable<Vlan[]> {
    return this.http.get(this.urlEndPointVlan + 'activas').pipe(
      map((resultado) => resultado as Vlan[]),
    );
  }

  consultarVlans(idCompania: number, idCiudad: number, idSede: number, idAmbiente: number): Observable<ConsultaVlansDto[]> {
    return this.http.get(this.urlEndPointVlan + 'consultar-vlan/' +  idCompania + '/' + idCiudad +
    '/' + idSede + '/' + idAmbiente).pipe(
    map((resultado) => resultado as ConsultaVlansDto[])
  );
  }

  InactivarVlan(vlanDto: ConsultaVlansDto): Observable<ConsultaVlansDto> {
    return this.http.post(this.urlEndPointVlan + 'inactivar', vlanDto,
    {responseType: 'json'}).pipe(
      map((resultado) => resultado as ConsultaVlansDto)
    );
  }

  public async exportarVlans(listaExportar: ConsultaVlansDto[]): Promise<Blob> {
    const file =  await this.http.post<Blob>(this.urlEndPointVlan + 'exportar',
    listaExportar, {responseType: 'blob' as 'json'}).toPromise();
    return file;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/vlan.service.ts